import type {
  BuildIconHeaderOptions,
  ColumnHeaderPresentation,
} from '../types';

export const buildIconHeader = (
  label: string,
  options: BuildIconHeaderOptions = {}
): ColumnHeaderPresentation => {
  const description =
    options.description !== undefined ? options.description : label;

  if (!options.iconNode) {
    return {
      content: label,
      popover: description,
    };
  }

  const ariaLabel =
    typeof description === 'string' && description.trim().length > 0
      ? description
      : label;

  return {
    content: (
      <span
        className="d-inline-flex align-items-center justify-content-center w-100"
        aria-label={typeof ariaLabel === 'string' ? ariaLabel : undefined}
      >
        {options.iconNode}
        <span className="visually-hidden">{label}</span>
      </span>
    ),
    popover: description,
  };
};
